import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';
import useOnclickOutside from 'react-cool-onclickoutside';
import { translate } from '../../Services/translation';
import Fuse from 'fuse.js';

const mapOptions = {
  types: ['geocode'],
};

const PlacesAutocomplete = ({
  dealers,
  map,
  mapApi,
  addplace,
  gotoPlace,
  setNewLocation,
  placesService,
  autocompleteFocusIndex,
  setAutocompleteFocusIndex,
  selectDealer,
  scrollToDealerListTop,
  setZoom,
}) => {
  const [placeList, setPlaceList] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [fuse, setFuse] = useState(false);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      types: ['geocode'],
    },
    debounce: 300,
  });
  const ref = useOnclickOutside(() => {
    // When the user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
    setPlaceList([]);
  });
  useEffect(() => {
    //setReady(true);
  }, []);

  useEffect(() => {
    if (dealers?.length > 0) {
      // Fuzzy search
      setFuse(
        new Fuse(dealers, {
          keys: [
            'name',
            'dealerAddressData.address',
            'dealerAddressData.address2',
            'dealerAddressData.city',
            'dealerAddressData.country',
            'dealerAddressData.zipCode',
          ],
          threshold: 0.3,
          distance: 100,
        })
      );
      if (searchQuery?.length > 0) {
        filterItems(searchQuery);
      }
    }
  }, [dealers]);

  useEffect(() => {
    if (searchQuery?.length > 0) {
      filterItems(searchQuery);
      setValue(searchQuery);
    }
  }, [searchQuery]);

  const clearPlacesList = () => {
    setPlaceList([]);
    clearSuggestions();
  };

  const triggerNewSearch = () => {
    if (searchQuery?.length > 0) {
      filterItems(searchQuery);
      setValue(searchQuery);
    }
  };

  const filterItems = (searchQuery) => {
    if (!searchQuery || searchQuery.trim().length === '') {
      setPlaceList([]);
      return;
    }
    if (fuse) {
      const q = searchQuery.trim();
      const _result = fuse.search(q);
      setPlaceList(_result);
    }
  };
  const handleSelectPlacesList = (position, name) => {
    setSearchQuery(name);
    setNewLocation(position);
    setZoom(9);
    selectDealer(name);
    scrollToDealerListTop();
    setTimeout(clearPlacesList, 1500);
  };
  const handleSelect = (description) => () => {
    // When the user selects a place, we can replace the keyword without request data from API
    // by setting the second parameter to "false"
    setValue(description, false);
    setSearchQuery(description);
    clearPlacesList();

    // Get latitude and longitude via utility functions
    getGeocode({ address: description }).then((results) => {
      const { lat, lng } = getLatLng(results[0]);
      setNewLocation({ lat, lng });
    });
  };

  return (
    <div
      className="dealer-page__search small-12 large-5 columns dealer-page__item--fade-in"
      ref={ref}
    >
      <label htmlFor="dpSearch">{translate('dealer.search')}</label>
      <div className="dealer-page__search-input-wrapper">
        <input
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => triggerNewSearch()}
          disabled={!ready}
          className="searchInput"
          placeholder={translate('dealer.enterlocation')}
          type="text"
        />
        <button onClick={() => {}}></button>
      </div>
      {(placeList?.length > 0 || (status === 'OK' && data?.length > 0)) && (
        <ul className="dealer-page__search-input-result">
          {status === 'OK' &&
            data?.length > 0 &&
            data.map((suggestion, index) => {
              const { place_id, description } = suggestion;
              return (
                <li
                  key={`${place_id}-${index}`}
                  onClick={handleSelect(description)}
                >
                  <strong>{description}</strong>
                </li>
              );
            })}
          {placeList?.length > 0 &&
            placeList.map((item, index) => {
              const place = item.item || item;
              return (
                <li
                  key={`gm-autocompl-${index}`}
                  className=""
                  onClick={() =>
                    handleSelectPlacesList(
                      {
                        lat: parseFloat(place.latitude),
                        lng: parseFloat(place.longitude),
                      },
                      place.name
                    )
                  }
                >
                  {place.name.trim()}
                </li>
              );
            })}
        </ul>
      )}
    </div>
  );
};

export default React.memo(PlacesAutocomplete);
